<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-toc" epub:type="toc" id="table-of-contents" role="doc-toc">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/introduction"><span class="item-title-text">Introduction</span></a></p>
<p class="item-author">by Ken Foree</p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chokepoint"><span class="item-title-text">Chokepoint</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/fatgirlwithaknife"><span class="item-title-text">Fat Girl with a Knife</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/lonegunman"><span class="item-title-text">Lone Gunman</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/notthiswarnotthisworld"><span class="item-title-text">Not this War, Not this World</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/callingdeath"><span class="item-title-text">Calling Death</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/gavinfunkesmonstermoviemarathon"><span class="item-title-text">Gavin Funke’s Monster Movie Marathon</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/cadaverdog"><span class="item-title-text">Cadaver Dog</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/overduebooks"><span class="item-title-text">Overdue Books</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/asmalltasteoftheoldcountry"><span class="item-title-text">A Small Taste of the Old Country</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/sisters" title="Link target outside of Sample"><span class="item-title-text">Sisters</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/jackandjill"><span class="item-title-text">Jack and Jill</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/thewindthroughthefence"><span class="item-title-text">The Wind Through the Fence</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/jingoandthehammerman"><span class="item-title-text">Jingo and the Hammerman</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/thedeathpoemofsenseiotoro"><span class="item-title-text">The Death Poem of Sensei Ōtoro</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/sonofthedevil"><span class="item-title-text">Son of the Devil</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/peglegandpaddysavetheworld"><span class="item-title-text">Pegleg And Paddy Save the World</span></a></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/abouttheauthor"><span class="item-title-text">About the Author</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/ifyouliked"><span class="item-title-text">If You Liked …</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/otherwordfirepresstitles"><span class="item-title-text">Other WordFire Press Titles</span></a></p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?837d4bf0